import gql from 'graphql-tag';

import { fragmentBettingOpportunities, getBet, getEvent, getMarkets } from '../fragments';

const deviceStatusMessagePayload = gql`
  fragment DeviceStatusMessagePayloadFragment on DeviceStatusMessagePayload {
    inaccessible
    immediate
    delaySecs
  }
`;

export const PERIPHERAL_MESSAGES_SUBSCRIPTION = gql`
  subscription(
    $schemaVersion: String!
    $venueId: String!
    $slotNumber: Int!
    $deviceType: String!
    $messageTypes: [String!]
  ) {
    sub: peripheralMessages(
      where: {
        schemaVersion: $schemaVersion
        venueId: $venueId
        deviceType: $deviceType
        slotNumber: $slotNumber
        messageTypes: $messageTypes
      }
    ) {
      metadata {
        request {
          id
          peripheral
        }
        message {
          id
          topic
          offset
          type
        }
      }
      payload {
        ... on PrintFailureMessagePayload {
          barcode
          reason
        }
        ... on BetScannedMessagePayload {
          timestamp
          bet: data {
            ${getBet()}
          }
        }
        ... on BuiltBetScannedMessagePayload {
          timestamp
          data {
            barcode
            requestedSelectionCount
            retrievedSelectionCount
            events {
              ${getEvent()}
              ${getMarkets()}
            }
            opportunities {
              ...opportunities
            }
          }
        }
        ... on DeviceErrorMessagePayload {
          timestamp
        }
        ... on VoucherScannedMessagePayload {
          voucher: data {
            ticketId
          }
        }
        ... on NoteInsertedMessagePayload {
          timestamp
          value
          currency
        }
        ... on ContestCardMessagePayload {
          contest {
            type
            id
          }
          contestEntryId
          picks
        }
        ... on ParlayCardScannedMessagePayload {
          timestamp
        }
        ... on ParlayCardStubMessagePayload {
          edition {
            editionId
            title
            type
            betType
            jackpot
          }
          selections {
            betEngineSelId
            betEngineMarketId
            betEngineEventId
            betEngineSelName
            betEngineMarketName
            betEngineEventName
            fbResult
            cardLine
            selectionOrder
            starred
            flagged
          }
          stake
          warnings {
            code
            description
            details
          }
        }
        ... on InvalidDataMessagePayload {
          timestamp
          errorCode
          errorMessage
        }
        ... on ContestEntryScannedMessagePayload {
          timestamp
          contestData: data
        }
        ... on DeviceDoAssociationMessagePayload {
          timestamp
          deviceSessionId
          playerId
          challenge
          maxAttempts
        }
        ...DeviceStatusMessagePayloadFragment
      }
    }
  }

  ${fragmentBettingOpportunities}
  ${deviceStatusMessagePayload}
`;
